import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLogin from "./AdminLogin";
import AdminGuard from "./AdminGuard";
import AdminLayout from "./AdminLayout";
import AdminDashboard from "./AdminDashboard";
import ResourceManager from "./ResourceManager";
import AdminNotifications from "./AdminNotifications";
import AdminPartnerManager from "./AdminPartnerManager";

const AdminRoutes = () => (
  <Routes>
    <Route path="login" element={<AdminLogin />} />
    <Route element={<AdminGuard />}>
      <Route element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="notifications" element={<AdminNotifications />} />
        <Route path="partner-management" element={<AdminPartnerManager />} />
        <Route path=":resourceKey" element={<ResourceManager />} />
      </Route>
    </Route>
    <Route path="*" element={<Navigate to="/admin" replace />} />
  </Routes>
);

export default AdminRoutes;
